import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import authReducer from './authSlice';
import breadCrumbReducer from './breadCrumbSlice';
import formReducer from './formSlice';
import AdultLiteracyReducer from './AdultLiteracySlice';
import dashboardReducer from './dashboardSlice';
import numeracyLiteracyReducer from './numeracyLiteracySlice';
import ictSkillsReducer from './ictSkillsSlice';
import exportReducer from './exportSlice';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

const persistConfig = {
  key: 'auth',
  storage,
  whitelist: ['user', 'token'], // Persist only auth state
};

const persistedAuthReducer = persistReducer(persistConfig, authReducer);

const store = configureStore({
  reducer: {
    form: formReducer,
    numeracyLiteracy: numeracyLiteracyReducer,
    AdultLiteracy: AdultLiteracyReducer,
    ictSkills: ictSkillsReducer,
    auth: persistedAuthReducer,
    breadcrumb: breadCrumbReducer,
    dashboard: dashboardReducer,
    export: exportReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // redux-persist actions need to be ignored
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export default store;